import React from 'react';
import Input from '../../../components/ui/Input';

const ServiceBusinessForm = ({ formData, onUpdate }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Total Number of Services"
          type="number"
          placeholder="Enter number"
          value={formData?.totalServices || ''}
          onChange={(e) => onUpdate({ totalServices: e?.target?.value })}
          required
        />

        <Input
          label="Highest Revenue Service"
          type="text"
          placeholder="Service name"
          value={formData?.highestRevenueService || ''}
          onChange={(e) => onUpdate({ highestRevenueService: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Highest Profit Margin Service"
          type="text"
          placeholder="Service name"
          value={formData?.highestProfitService || ''}
          onChange={(e) => onUpdate({ highestProfitService: e?.target?.value })}
          required
        />

        <Input
          label="Average Service Delivery Time (Days)"
          type="number"
          placeholder="Enter days"
          value={formData?.avgDeliveryTime || ''}
          onChange={(e) => onUpdate({ avgDeliveryTime: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Customer Repeat Rate (%)"
          type="number"
          placeholder="e.g., 75"
          value={formData?.customerRepeatRate || ''}
          onChange={(e) => onUpdate({ customerRepeatRate: e?.target?.value })}
          required
        />

        <Input
          label="Monthly New Customers Acquired"
          type="number"
          placeholder="Enter number"
          value={formData?.monthlyNewCustomers || ''}
          onChange={(e) => onUpdate({ monthlyNewCustomers: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Average Ticket Size (₹)"
          type="number"
          placeholder="₹0"
          value={formData?.avgTicketSize || ''}
          onChange={(e) => onUpdate({ avgTicketSize: e?.target?.value })}
          required
        />

        <Input
          label="Team Size"
          type="number"
          placeholder="Enter number"
          value={formData?.teamSize || ''}
          onChange={(e) => onUpdate({ teamSize: e?.target?.value })}
          required
        />
      </div>

      <div className="p-4 bg-primary/10 border border-primary/20 rounded-md">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/20 rounded-md">
            <svg className="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">System Calculations</p>
            <p className="text-xs text-muted-foreground mt-1">
              Based on your inputs, we'll calculate: Capacity limit, Scalability index, and Revenue growth potential
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceBusinessForm;